import { MailIcon, PhoneIcon, PlayIcon } from 'lucide-react';
import React, { useState, useEffect, useRef } from 'react';
import { BsTwitterX } from 'react-icons/bs';
import { FaInstagram, FaStreetView, FaTelegram, FaYoutube } from 'react-icons/fa';
import { FaLocationPin, FaTiktok, FaWhatsapp } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function Contact() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  const fetchSectionHero = async () => {      
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/sectionhero/contact`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setSectionHero(json.data[0] || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };
  
  useEffect(() => {
    fetchSectionHero();
  }, []);  

  const [sectionHero, setSectionHero] = useState({
    title: "",
    page: "",
    description: "",
    image: "", 
  });

  const clickMaps = () => {
    // Perform any logic here before navigating
    window.open("https://maps.app.goo.gl/orU8WGav3zU4Ma2A6", "_blank")
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const executeCaptcha = () => {
    return new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute("6LcIY4EsAAAAADoIsHMQruBeXbRjcC2MdVvnJ0j7", { action: "contact" })
          .then((token) => {
            resolve(token);
          });
      });
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = await executeCaptcha();

    const formDatas = new FormData();
    Object.keys(formDatas).forEach((key) => {
      formDatas.append(key, formDatas[key]);
    });

    formDatas.append("captcha_token", token);

    // Member
    formDatas.append("name", formData.name);
    formDatas.append("email", formData.email);
    formDatas.append("subject",formData.subject);
    formDatas.append("message", formData.message);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/contact/send`,
        {
          method: "POST",
          body: formDatas,
        }
      );

      const result = await response.json();

      if (!response.ok) {
        alert("Error: " + result.message);
        return;
      }
      Swal.fire({
        title: "Sukses mengirim Pesan",
        text: "Terima kasih telah mengirim pesan kepada Kami, tim Customer Service Kami akan segera merespon pesan Anda",
        icon: "success",
        draggable: true
      }).then(() => {
        setSubmitted(true);
      });
    } catch (err) {
      console.error(err);
    }
  };

  const [contactData, setContactData] = useState(true);
  
  const fetchContactData = async () => {
    
      try {
          const res = await fetch(
              `${process.env.REACT_APP_BASE_URL}api/contactdata/1`
          );
  
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
          const json = await res.json();
          setContactData(json.data || []);
  
      } catch (err) {
          console.error("Fetch Running error:", err);
      }
    };
    
    useEffect(() => {
      fetchContactData();
    }, []); 


  if (submitted) {
    return (
      <div className="min-h-screen bg-cream pt-24 flex items-center justify-center px-6">
        <div className="max-w-lg w-full bg-white rounded-2xl shadow-hover p-12 text-center">
          <div className="w-20 h-20 rounded-full bg-amber-pale flex items-center justify-center mx-auto mb-6 text-4xl">
            🎉
          </div>
          <h2 className="font-display font-bold text-navy text-3xl mb-3">Terima kasih Pengunjung radarpulsa.com</h2>
          <p className="font-body text-slate-muted text-base mb-2">
            Terima kasih, <strong className="text-navy">{formData.name}</strong>. Pesan Anda telah terkirim.
          </p>
          <p className="font-body text-slate-muted text-sm mb-8">
            Tim kami akan segera melakukan pengecekan dan meresponse pesan Anda ke <strong>{formData.email}</strong>.
          </p>
          <a href="/" className="btn-primary justify-center w-full">Kembali ke Beranda</a>
        </div>
      </div>
    );
  }

 
  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section
        data-section="header"
        className="
          relative
          h-[32vh] md:h-[40vh] lg:h-[45vh]
          overflow-hidden
          flex items-center justify-center
          bg-slate-950
        "
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={`${process.env.REACT_APP_BASE_URL}uploads/images/${sectionHero.image}`}
            alt="background"
            className="w-full h-full object-cover"
          />
          
          {/* Overlay depth */}
          <div className="absolute inset-0 bg-slate-950/60"></div>

          {/* Gradient Glow */}
          <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 via-slate-950/50 to-slate-950"></div>

          {/* Optional Glow Accent */}
          <div className="absolute top-1/4 left-1/3 w-72 h-72 bg-blue-500/20 blur-[120px] rounded-full"></div>
          <div className="absolute bottom-1/4 right-1/3 w-72 h-72 bg-red-500/20 blur-[120px] rounded-full"></div>
        </div>

        {/* Content */}
        <div
          className={`
            relative z-10
            px-6
            text-center
            max-w-5xl
            mx-auto
            translate-y-[2vh]
            transition-all duration-1000
            ${
              visibleSections.has("header")
                ? "opacity-100"
                : "opacity-0 translate-y-[5vh]"
            }
          `}
        >
          <h1
            className="
              font-bricolage
              font-bold
              tracking-tight
              leading-tight
              mb-4
              bg-gradient-to-r
              from-blue-400 via-white to-red-400
              bg-clip-text text-transparent
              text-[clamp(2rem,6vw,4.5rem)]
            "
          >
            {sectionHero.page}
          </h1>

          <div className="w-16 md:w-24 h-1 rounded-full bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-5"></div>

          <p
            className="
            mx-auto
            max-w-xs sm:max-w-2xl
            text-gray-300
            leading-relaxed
            text-[clamp(.95rem,1.8vw,1.15rem)]
            "
          >
            {sectionHero.description}
          </p>
        </div>
      </section>

      {/* Contact Form & Info Section */}
      <section 
        data-section="contact"
        className="py-16 md:py-24 bg-slate-950"
      >
        <div
          className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
            visibleSections.has('contact')
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="grid lg:grid-cols-5 gap-8 md:gap-12">

            {/* ================= LEFT ================= */}
            <div className="lg:col-span-2 space-y-6 md:space-y-8">

              {/* TITLE */}
              <div>
                <h2 className="font-bricolage text-2xl md:text-3xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
                  Informasi Kontak
                </h2>
                <p className="text-gray-400 text-sm md:text-base mb-6 md:mb-8">
                  Isi Form disamping ini, dan tim cepat Kita akan langsung memberikan respon.
                </p>
              </div>

              {/* CONTACT LIST */}
              <div className="space-y-4 md:space-y-6">

                {[ 
                  { icon: <MailIcon size={20} />, title: "Email", value: contactData.email },
                  { icon: <PhoneIcon size={20} />, title: "Telpon", value: contactData.phone },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex items-start gap-3 md:gap-4 p-4 md:p-6 bg-slate-800/50 backdrop-blur-sm rounded-xl border border-slate-700 hover:border-blue-500/50 transition-all duration-300 md:hover:scale-105"
                  >
                    <div className="text-white">{item.icon}</div>
                    <div>
                      <h3 className="text-sm md:text-lg font-semibold text-white mb-1">
                        {item.title}
                      </h3>
                      <p className="text-gray-400 text-xs md:text-sm">
                        {item.value}
                      </p>
                    </div>
                  </div>
                ))}

                {/* WHATSAPP */}
                <div className="flex items-start gap-3 md:gap-4 p-4 md:p-6 bg-slate-800/50 backdrop-blur-sm rounded-xl border border-slate-700 hover:border-blue-500/50 transition-all duration-300 md:hover:scale-105">
                  <FaWhatsapp size={20} />
                  <div>
                    <h3 className="text-sm md:text-lg font-semibold text-white mb-1">
                      Whatsapp
                    </h3>
                    {[contactData.whatsapp1, contactData.whatsapp2, contactData.whatsapp3].map((wa, i) => (
                      <p key={i} className="text-gray-400 text-xs md:text-sm">
                        +{wa}
                      </p>
                    ))}
                  </div>
                </div>

              </div>

              {/* SOCIAL */}
              <div>
                <h3 className="text-base md:text-xl font-semibold mb-3 md:mb-4 text-white">
                  Follow Kami:
                </h3>

                <div className="flex gap-2 md:gap-3">
                  {[ 
                    { link: contactData.instagram, icon: <FaInstagram size={18} /> },
                    { link: contactData.telegram, icon: <FaTelegram size={18} /> },
                    { link: contactData.youtube, icon: <FaYoutube size={18} /> },
                    { link: contactData.tiktok, icon: <FaTiktok size={18} /> },
                  ].map((item, i) => (
                    <a
                      key={i}
                      href={`https://${item.link}`}
                      target="_blank"
                      className="w-10 h-10 md:w-12 md:h-12 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 md:hover:scale-110"
                    >
                      {item.icon}
                    </a>
                  ))}
                </div>
              </div>

            </div>

            {/* ================= FORM ================= */}
            <div className="lg:col-span-3 order-first lg:order-none">
              <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700 p-5 md:p-12">

                <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">

                  <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Nama Anda..."
                      className="input-style"
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="your@email.com"
                      className="input-style"
                      required
                    />
                  </div>

                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Judul Pesan..."
                    className="input-style"
                    required
                  />

                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    placeholder="Tuliskan Pesan Anda disini..."
                    className="input-style resize-none"
                    required
                  />

                  <button
                    type="submit"
                    className="w-full py-3 md:py-4 bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold text-sm md:text-lg hover:shadow-xl md:hover:shadow-2xl hover:shadow-blue-500/50 transform md:hover:scale-105 transition-all duration-300"
                  >
                    Kirim Pesan
                  </button>

                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Map Section (Placeholder) */}
      <section 
        data-section="map"
        className="py-4 bg-gradient-to-b from-slate-950 to-slate-900"
      >
        {/* <a
          href="https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=-6.9435976895685805, 107.62701756755487"
          target="_blank"
          className=""
        >
          <div className='flex justify-center p-6'>
            <div className="px-6 flex items-center text-white gap-2 flex-row py-4 bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300 cursor-pointer">
                <FaStreetView size={21}></FaStreetView> Buka Google Street View
            </div>
          </div>
        </a> */}
        <div className={`cursor-pointer max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 hover:scale-105 ${
          visibleSections.has('map') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="relative h-[600px] rounded-2xl overflow-hidden">
            {/* VIDEO LAYER */}
            {!isFinished && (
              <div className="absolute inset-0 z-10 flex items-center justify-center">
                
                <video
                  className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${
                    isPlaying ? 'opacity-100' : 'opacity-40'
                  }`}
                  onEnded={() => setIsFinished(true)}
                >
                  <source src="/images/map-radar.mp4" type="video/mp4" />
                </video>

                {/* PLAY BUTTON */}
                {!isPlaying && (
                  <button
                    onClick={() => {
                      const video = document.querySelector("video");
                      video.play();
                      setIsPlaying(true);
                    }}
                    className="relative z-20 px-6 flex items-center text-white gap-2 flex-row py-4 bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300 cursor-pointer"
                  >
                    <PlayIcon/>
                  </button>
                )}
              </div>
            )}

            {/* MAP LAYER */}
            <iframe
              className={`w-full h-full transition-opacity duration-700 ${
                isFinished ? 'opacity-100' : 'opacity-0'
              }`}
              src="https://www.google.com/maps/embed?pb=!4v1777694534221!6m8!1m7!1supfwkkoy-Zn_ejiuFsADxA!2m2!1d-6.943919462278995!2d107.6271205789915!3f17.16932761803104!4f12.301633574004171!5f0.7820865974627469"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section 
        data-section="cta"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>

        <div
          className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
            visibleSections.has('cta')
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10'
          }`}
        >
          {/* TITLE */}
          <h2 className="font-bricolage text-2xl sm:text-3xl md:text-5xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent leading-tight">
            Ayo bergabung menjadi mitra Kami!
          </h2>

          {/* DESC */}
          <p className="text-sm sm:text-base md:text-xl text-gray-400 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>

          {/* BUTTON */}
          <div className="flex justify-center">
            <Link
              to="https://play.google.com/store/apps/details?id=com.otoreport.radarpulsa&hl=id"
              target="_blank"
              className="
                w-full sm:w-auto
                px-6 sm:px-8 md:px-10
                py-3 sm:py-4
                bg-gradient-to-r from-blue-600 to-red-600
                rounded-full
                font-semibold
                text-sm sm:text-base md:text-lg
                text-center
                hover:shadow-xl md:hover:shadow-2xl
                hover:shadow-blue-500/40
                transform md:hover:scale-105
                transition-all duration-300
              "
            >
              Mulai mendaftar
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
